type Page = {
  name: string;
  path: RegExp;
};

// WithHandlerで該当するpathに対してNginxにリダイレクトさせる
// フロー: リリース前のページpathをここに定義する -> Next.jsでの開発が終わったらページpathをここから外す -> Nginxの設定を変更する
export const UnReleasedPages: Page[] = [];

export const isReleasedInActiveStatus = (): boolean => {
  return true;
};

export const isReleasedRedesignRecruitment = (): boolean => {
  return true;
};

export const isReleasedRedesignTop = (): boolean => {
  return true;
};

export const isReleasedEntryManagement = (): boolean => {
  // UnReleasedPagesにmypage/entry_managementsがある場合はfalseを返す
  return !UnReleasedPages.some((page) =>
    page.path.test('/mypage/entry_managements/'),
  );
};

export const isReleasedAiToDoCreationFlow = (): boolean => {
  return true;
};

export const isReleasedCareerAdviser = (): boolean => {
  // UnReleasedPagesにcareer_adviserがある場合はfalseを返す
  return !UnReleasedPages.some((page) => page.path.test('/career_adviser/'));
};

export const isReleasedNewRegisterFlow = (): boolean => {
  return true;
};
